import Header from "./components/common/header";
import Footer from "./components/common/footer";
import SupportChatWidget from "./components/common/SupportChatWidget";
import SeoManager from "./components/common/SeoManager";
import Home from "./components/pages/home/home";
import FindProperty from "./components/pages/find-property/find-property";
import CardPopup from "./components/pages/find-property/components/cardpopup";
import ListProperty from "./components/pages/list-property/list-proprty";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "./components/pages/login/login";
import OAuthCallback from "./components/pages/login/oauth-callback";
import CompleteProfile from "./components/pages/login/complete-profile";
import Signup from "./components/pages/signup/signup";
import OwnerDashboard from "./components/pages/owner-dashboard/owner-dashboard";
import RenterDashboard from "./components/pages/renter-dashboard/renter-dashboard";
import Messages from "./components/pages/messages/messages";
import RentalApplication from "./components/pages/rental-application/rental-application";
import ProtectedRoute from "./components/common/protected-route";
import ForgotPassword from "./components/pages/forgot-password/forgot-password";
import ResetPassword from "./components/pages/reset-password/reset-password";
import PrivacyPolicy from "./components/pages/legal/PrivacyPolicy";
import TermsOfService from "./components/pages/legal/TermsOfService";
import CookiePolicy from "./components/pages/legal/CookiePolicy";
import HelpCenter from "./components/pages/help/HelpCenter";
import CommunityGuidelines from "./components/pages/community/CommunityGuidelines";
import SafetyCenter from "./components/pages/safety/SafetyCenter";
import ContactUs from "./components/pages/contact/ContactUs";
import AboutUs from "./components/pages/about/AboutUs";
import SeoLandingPage from "./components/pages/seo/SeoLandingPage";
import KycVerification from "./components/pages/kyc-verification/kyc-verification";
import Profile from "./components/pages/profile/profile";
import PropertySettings from "./components/pages/property-settings/property-settings";
import PropertyDashboard from "./components/pages/property-dashboard/PropertyDashboard";

// Admin
import AdminLogin          from "./components/pages/admin/AdminLogin";
import AdminProtectedRoute from "./components/pages/admin/AdminProtectedRoute";
import AdminDashboard      from "./components/pages/admin/AdminDashboard";
import AdminKycQueue       from "./components/pages/admin/AdminKycQueue";
import AdminPropertyVerificationQueue from "./components/pages/admin/AdminPropertyVerificationQueue";
import AdminUsers          from "./components/pages/admin/AdminUsers";
import AdminProperties     from "./components/pages/admin/AdminProperties";
import AdminSupport        from "./components/pages/admin/AdminSupport";
import AdminTeam           from "./components/pages/admin/AdminTeam";
import AdminLogs           from "./components/pages/admin/AdminLogs";
import AdminSystem         from "./components/pages/admin/AdminSystem";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const hideSupportChat = ["/login", "/signup", "/forgot-password", "/reset-password", "/auth/callback", "/complete-profile"].includes(location.pathname);

  return (
    <div className="App">
      <SeoManager />
      {!isAdminRoute && <Header />}

      <Routes>
        {/* ── Public / user routes ─────────────────────────────── */}
        <Route path="/" element={<Home/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/auth/callback" element={<OAuthCallback/>}/>
        <Route path="/complete-profile" element={
          <ProtectedRoute>
            <CompleteProfile/>
          </ProtectedRoute>
        }/>
        <Route path="/find-property" element={<FindProperty/>}/>
        <Route path="/rent/:citySlug" element={<SeoLandingPage variant="cityHub"/>}/>
        <Route path="/rent/:citySlug/:categorySlug" element={<SeoLandingPage variant="rentCategory"/>}/>
        <Route path="/gharbhada-:citySlug" element={<SeoLandingPage variant="gharbhadaCity"/>}/>
        <Route path="/flat-bhada-:citySlug" element={<SeoLandingPage variant="flatBhadaCity"/>}/>
        <Route path="/room-rent-:citySlug" element={<SeoLandingPage variant="roomRentCity"/>}/>
        <Route path="/cheap-kotha-bhada-near-college" element={<SeoLandingPage variant="cheapKothaNearCollege"/>}/>
        <Route path="/property/:propertyId" element={<CardPopup/>}/>
        <Route path="/apply/:propertyId" element={
          <ProtectedRoute allowedRoles={["renter"]}>
            <RentalApplication/>
          </ProtectedRoute>
        }/>
        <Route path="/list-property" element={
          <ProtectedRoute allowedRoles={["owner"]}>
            <ListProperty/>
          </ProtectedRoute>
        }/>
        <Route path="/signup" element={<Signup/>}/>
        <Route path="/owner-dashboard" element={
          <ProtectedRoute allowedRoles={["owner"]}>
            <OwnerDashboard/>
          </ProtectedRoute>
        }/>
        <Route path="/property-settings/:propertyId" element={
          <ProtectedRoute allowedRoles={["owner"]}>
            <PropertySettings/>
          </ProtectedRoute>
        }/>
        <Route path="/property-dashboard/:propertyId" element={
          <ProtectedRoute allowedRoles={["owner"]}>
            <PropertyDashboard/>
          </ProtectedRoute>
        }/>
        <Route path="/renter-dashboard" element={
          <ProtectedRoute allowedRoles={["renter"]}>
            <RenterDashboard/>
          </ProtectedRoute>
        }/>
        <Route path="/messages" element={
          <ProtectedRoute allowedRoles={["owner", "renter"]}>
            <Messages/>
          </ProtectedRoute>
        }/>
        <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/reset-password" element={<ResetPassword/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
        <Route path="/terms-of-service" element={<TermsOfService/>}/>
        <Route path="/cookie-policy" element={<CookiePolicy/>}/>
        <Route path="/help" element={<HelpCenter/>}/>
        <Route path="/community-guidelines" element={<CommunityGuidelines/>}/>
        <Route path="/safety" element={<SafetyCenter/>}/>
        <Route path="/contact" element={<ContactUs/>}/>
        <Route path="/about" element={<AboutUs/>}/>
        <Route path="/kyc-verification" element={
          <ProtectedRoute allowedRoles={["renter", "owner"]}>
            <KycVerification/>
          </ProtectedRoute>
        }/>
        <Route path="/profile" element={
          <ProtectedRoute allowedRoles={["renter", "owner"]}>
            <Profile/>
          </ProtectedRoute>
        }/>

        {/* ── Admin routes (no Header/Footer) ──────────────────── */}
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route path="/admin/dashboard" element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/kyc" element={
          <AdminProtectedRoute allowedRoles={["super_admin","kyc_verifier"]}>
            <AdminKycQueue />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/property-verifications" element={
          <AdminProtectedRoute allowedRoles={["super_admin","property_verifier"]}>
            <AdminPropertyVerificationQueue />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/users" element={
          <AdminProtectedRoute allowedRoles={["super_admin","support"]}>
            <AdminUsers />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/properties" element={
          <AdminProtectedRoute allowedRoles={["super_admin","support","property_verifier"]}>
            <AdminProperties />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/tickets" element={
          <AdminProtectedRoute allowedRoles={["super_admin","support"]}>
            <AdminSupport />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/team" element={
          <AdminProtectedRoute allowedRoles={["super_admin"]}>
            <AdminTeam />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/logs" element={
          <AdminProtectedRoute allowedRoles={["super_admin","technician"]}>
            <AdminLogs />
          </AdminProtectedRoute>
        }/>
        <Route path="/admin/system" element={
          <AdminProtectedRoute allowedRoles={["super_admin","technician"]}>
            <AdminSystem />
          </AdminProtectedRoute>
        }/>
      </Routes>

      {!isAdminRoute && !hideSupportChat && <SupportChatWidget />}
      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default App;
